<template>
  <div :id="`${source}_image_preview`">
    <CustomModal v-model:visible="modal_visible" :variant="variants.VARIANT2">
      <div class="image_preview_container">
        <img :src="url" alt="Preview" class="image_preview_img" />
      </div>
    </CustomModal>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { variants } from "@/src/constants/customComponentConstants.js";
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  source: { type: String, required: true },
  url: { type: String, default: "" },
  visible: { type: Boolean, default: false },
});

const emit = defineEmits(["update:visible"]);

const modal_visible = ref(props.visible);

watch(
  () => props.visible,
  (new_val) => {
    modal_visible.value = new_val;
  },
);

watch(
  () => modal_visible.value,
  (new_val) => {
    emit("update:visible", new_val);
  },
);
</script>

<style scoped>
.image_preview_container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.image_preview_img {
  max-width: 80vw;
  max-height: calc(80vh - 48px);
  object-fit: contain;
  border-radius: 8px;
}
</style>
